import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import '../stylings/Header.css';

export default function Header() {
  return (
    <div className="site-header">
      <div className="container-fluid px-4">
        <div className="row align-items-center">
          <div className="col-lg-2 col-md-3 col-4">
            <Link to="/">
              <img src={logo} alt="Akash Model School Logo" className="header-logo" />
            </Link>
          </div>
          <div className="col-lg-7 col-md-6 d-none d-md-block text-center">
            <div className="header-school-name">
              <h1 className="school-name-main">Akash Model Sr. Sec. School</h1>
              <p className="school-name-sub">
                Baljeet Vihar, Nithari Extn. Near Rohini Sec-22, New Delhi-110086
              </p>
              <p className="school-affiliation">
                <span className="affil-badge">CBSE Affiliated</span>
                <span className="affil-motto">Work Is Worship</span>
              </p>
            </div>
          </div>
          {/* ERP Login only on md+ — mobile sees it in Navbar */}
          <div className="col-lg-3 col-md-3 d-none d-md-flex justify-content-end align-items-center gap-3">
            <Link to="/login" className="erp-login-btn">
              <i className="fas fa-user-circle me-1"></i> ERP Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
